<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.index,
                    },
                    {
                        name: group.name,
                        href: meta.links.show,
                    },
                    {
                        name: $t('messages.tools'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <GroupToolsStudentList
                :students="group.students"
                :absent="group.absent"
                :list-form-route="route('groups.tools.list', { group: group.id })"
            >
            </GroupToolsStudentList>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import GroupToolsStudentList from '@/components/pageSpecific/GroupToolsStudentList.vue';

export default {
    components: {
        PanelPage,
        GroupToolsStudentList,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'group'],
    data() {
        return {};
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
